(function () {
  var root = document.getElementById('bm-accessories');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var grid = $('[data-bm-acc-grid]');
  var cards = $$('[data-bm-acc-card]');
  var gridCards = $$('[data-bm-acc-card]', grid);
  var btns = $$('[data-bm-acc-machine]');
  var row = $('[data-bm-acc-row]');
  var titleEl = $('[data-bm-acc-title]');
  var countEl = $('[data-bm-acc-count]');
  var headEl = $('[data-bm-acc-head]');
  var showAll = $('[data-bm-acc-showall]');
  var empty = $('[data-bm-acc-empty]');
  var emptyTitle = $('[data-bm-acc-empty-title]');
  var live = $('[data-bm-acc-live]');
  var d = root.dataset;
  var names = {};
  (d.names || '').split('|').forEach(function (p) { var i = p.indexOf(':'); if (i > 0) names[p.slice(0, i)] = p.slice(i + 1); });
  var valid = ['all', 'gm3', 'ultra', 'gm2', 'nano'];
  var present = btns.map(function (b) { return b.dataset.bmAccMachine; });
  var current = null;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;

  function fill(t, k, v) { return (t || '').replace('{' + k + '}', v); }
  function fits(c, m) { return m === 'all' || (c.dataset.bmAccFits || '').split(' ').indexOf(m) > -1; }

  function reveal(btn) {
    if (!row || !btn || row.scrollWidth <= row.clientWidth) return;
    var l = btn.offsetLeft, r = l + btn.offsetWidth, pad = 20;
    if (l < row.scrollLeft + pad) row.scrollLeft = Math.max(0, l - pad);
    else if (r > row.scrollLeft + row.clientWidth - pad) row.scrollLeft = r - row.clientWidth + pad;
  }

  function apply(m, opts) {
    opts = opts || {};
    var hiddenMachine = m !== 'all' && present.indexOf(m) < 0;
    if (hiddenMachine) m = 'all';
    var was = cards.map(function (c) { return !c.hidden; });
    cards.forEach(function (c, i) {
      var show = fits(c, m);
      c.hidden = !show;
      c.classList.remove('is-in');
      if (show && !was[i] && !reduce && current !== null) c.classList.add('is-in');
    });
    var sorted = gridCards.slice().sort(function (a, b) {
      var A = a.dataset, B = b.dataset;
      return (A.tier - B.tier) || ((m !== 'all' ? +A.standalone : 0) - (m !== 'all' ? +B.standalone : 0)) || (A.order - B.order);
    });
    sorted.forEach(function (c) { grid.appendChild(c); });
    var first = true;
    sorted.forEach(function (c) { c.classList.toggle('is-first', !c.hidden && first); if (!c.hidden) first = false; });
    $$('.bma-chip').forEach(function (p) { p.classList.toggle('is-match', p.dataset.bmMachine === m); });
    $$('[data-bm-acc-note]').forEach(function (n) { n.textContent = n.getAttribute('data-box-' + m) || n.getAttribute('data-default'); });
    btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.bmAccMachine === m ? 'true' : 'false'); });
    var n = cards.filter(function (c) { return !c.hidden; }).length;
    var heading = m === 'all' ? d.tAll : fill(d.tMachine, 'machine', names[m]);
    titleEl.textContent = heading;
    countEl.textContent = n;
    showAll.hidden = m === 'all';
    var showEmpty = (n === 0 && m !== 'all') || hiddenMachine;
    empty.hidden = !showEmpty && n !== 0;
    headEl.hidden = showEmpty || n === 0;
    emptyTitle.hidden = !showEmpty;
    if (showEmpty) emptyTitle.textContent = fill(d.tEmpty, 'machine', hiddenMachine ? opts.asked : names[m]);
    live.textContent = showEmpty ? emptyTitle.textContent : (d.tLive || '').replace('{heading}', heading).replace('{count}', n);
    var u = new URL(location.href);
    if (m === 'all') u.searchParams.delete('machine'); else u.searchParams.set('machine', m);
    if (!opts.initial || u.href !== location.href) history.replaceState(null, '', u.href);
    current = m;
    btns.forEach(function (b) { if (b.dataset.bmAccMachine === m) reveal(b); });
  }

  btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.dataset.bmAccMachine); }); });
  showAll.addEventListener('click', function () { apply('all'); var a = $('[data-bm-acc-machine="all"]'); if (a) a.focus(); });
  $$('[data-bm-acc-chat]').forEach(function (b) {
    b.addEventListener('click', function () {
      var c = window.bmChatUx;
      if (c && typeof c.open === 'function') c.open(); else location.href = b.dataset.href;
    });
  });

  var sp = new URLSearchParams(location.search), stale = [];
  sp.forEach(function (v, k) { if (k.indexOf('filter.') === 0) stale.push(k); });
  var guardKey = 'bmAccFilterReload:' + location.pathname, guarded = false;
  try { guarded = sessionStorage.getItem(guardKey) === '1'; } catch (e) {}
  if (stale.length && !guarded) {
    stale.forEach(function (k) { sp.delete(k); });
    var q = sp.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
    try { sessionStorage.setItem(guardKey, '1'); } catch (e) {}
    location.reload();
    return;
  }
  if (!stale.length) { try { sessionStorage.removeItem(guardKey); } catch (e) {} }
  var asked = (new URLSearchParams(location.search).get('machine') || 'all').toLowerCase();
  if (valid.indexOf(asked) < 0) asked = 'all';
  if (asked === 'all') { current = 'all'; reveal($('[data-bm-acc-machine="all"]')); } else apply(asked, { initial: true, asked: names[asked] });
})();
